// src/provider.ts
import { ApolloProvider } from "@apollo/client";
export {
  ApolloProvider
};
